module.exports = __webpack_public_path__ + "img/AMB.759cedbd.svg";